import { createTmmApi } from "@org-avp/avp-avengers-tmm-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_MATERIAL_SERVICE_BASE_URL,
  prepareHeaders,
};

export const tmmApi: ReturnType<typeof createTmmApi> = createTmmApi({
  baseQueryArgs,
});
